module.exports = __webpack_public_path__ + "img/incubator-1.b9ece501.webp";